{
  "config": {
    "sections": [
      {
        "route": "/intro",
        "components": [
          {
            "type": "page",
            "elements": [
              {
                "type": "header",
                "value": "Section template: /intro",
                "position": 0,
                "elementId": "d6ee38e702046a69ba050067647931cb",
                "id": "d6ee38e702046a69ba050067647931cb"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 1,
                "elementId": "3e3d74f5d4d47902e532b50a0496cdf3",
                "id": "3e3d74f5d4d47902e532b50a0496cdf3"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 2,
                "elementId": "2cd9c9d22adaf1cdce02d358fc580eb6",
                "id": "2cd9c9d22adaf1cdce02d358fc580eb6"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 3,
                "elementId": "759d5b535af5d7382990dabdccea47c2",
                "id": "759d5b535af5d7382990dabdccea47c2"
              },
              {
                "type": "br",
                "position": 4,
                "elementId": "eeec13869f54a2ff160948c3b4422b2a",
                "id": "eeec13869f54a2ff160948c3b4422b2a"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 5,
                "elementId": "da9eddf783335fc303b3607a610324d3",
                "id": "da9eddf783335fc303b3607a610324d3"
              },
              {
                "type": "br",
                "position": 6,
                "elementId": "0a9775fcf55687df3f3b8954fc5db9cf",
                "id": "0a9775fcf55687df3f3b8954fc5db9cf"
              },
              {
                "type": "br",
                "position": 7,
                "elementId": "120644ca504e7692f55f0acbe9a4a89b",
                "id": "120644ca504e7692f55f0acbe9a4a89b"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 8,
                "elementId": "d365f7a65561f5fb6be05220a8c6fef1",
                "id": "d365f7a65561f5fb6be05220a8c6fef1"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 9,
                "elementId": "b5a9ea0ba6801540e8837df9afbbea24",
                "id": "b5a9ea0ba6801540e8837df9afbbea24"
              },
              {
                "type": "br",
                "position": 10,
                "elementId": "a1bfa689b9c60c3a8e289384319833f0",
                "id": "a1bfa689b9c60c3a8e289384319833f0"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 11,
                "elementId": "6c273b2f6880971aa0797f35ad1a616a",
                "id": "6c273b2f6880971aa0797f35ad1a616a"
              },
              {
                "type": "br",
                "position": 12,
                "elementId": "60160cff5244aa4a8f2ce8b636878bc8",
                "id": "60160cff5244aa4a8f2ce8b636878bc8"
              }
            ],
            "position": 0,
            "componentId": "18b1ead2781532fae7b5a403adf6666e",
            "id": "18b1ead2781532fae7b5a403adf6666e"
          }
        ],
        "properties": {
          "type": "singlepage"
        },
        "position": 0,
        "routeId": "bbe2709f1488020b81c0ba009f423db8",
        "id": "bbe2709f1488020b81c0ba009f423db8"
      },
      {
        "route": "/welcome",
        "components": [
          {
            "type": "page",
            "elements": [
              {
                "type": "header",
                "value": "Section template: /welcome",
                "position": 0,
                "elementId": "f485054f1082c28a6f306e34daf0e0e7",
                "id": "f485054f1082c28a6f306e34daf0e0e7"
              },
              {
                "type": "hr",
                "position": 1,
                "elementId": "160bc14b2009f7b474923a9f5fe8ac84",
                "id": "160bc14b2009f7b474923a9f5fe8ac84"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 2,
                "elementId": "72b413a37dc897cd1733461f53df79cf",
                "id": "72b413a37dc897cd1733461f53df79cf"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 3,
                "elementId": "db4e5d5e56d3876aa45593bc81cf2144",
                "id": "db4e5d5e56d3876aa45593bc81cf2144"
              },
              {
                "type": "br",
                "position": 4,
                "elementId": "6166a98b479758483f1adb96f5e13b01",
                "id": "6166a98b479758483f1adb96f5e13b01"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 5,
                "elementId": "1fe17fd5682a211dd72de7a0f94c8098",
                "id": "1fe17fd5682a211dd72de7a0f94c8098"
              },
              {
                "type": "hr",
                "position": 6,
                "elementId": "fad852494817816a70202b8a090affd2",
                "id": "fad852494817816a70202b8a090affd2"
              },
              {
                "type": "watch-now-button",
                "position": 7,
                "elementId": "4afaab6c0e47554955c2e8b8ab51b38b",
                "id": "4afaab6c0e47554955c2e8b8ab51b38b"
              }
            ],
            "properties": {
              "classes": "welcome-text-container"
            },
            "position": 0,
            "componentId": "2da8e661d2f148df1dfd4e50e258f983",
            "id": "2da8e661d2f148df1dfd4e50e258f983"
          }
        ],
        "position": 1,
        "routeId": "db5eba401ed5cd7db73b81a8ab88ef55",
        "id": "db5eba401ed5cd7db73b81a8ab88ef55"
      },
      {
        "route": "/intro-video",
        "components": [
          {
            "type": "video",
            "elements": [],
            "properties": {
              "duration": "2:13",
              "vimeoId": "436778005"
            },
            "position": 0,
            "componentId": "332bd252861f24dbf8d1bba766525dca",
            "id": "332bd252861f24dbf8d1bba766525dca"
          }
        ],
        "position": 2,
        "routeId": "2a05f0e51881b81cddd290500dbee3af",
        "id": "2a05f0e51881b81cddd290500dbee3af"
      },
      {
        "route": "/read",
        "components": [
          {
            "type": "page",
            "elements": [
              {
                "type": "header",
                "value": "Section template: /read",
                "properties": {
                  "classes": "how-long"
                },
                "position": 0,
                "elementId": "45b6ad73e32d6a31c9f6cac5d989afd0",
                "id": "45b6ad73e32d6a31c9f6cac5d989afd0"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 1,
                "elementId": "4f50192ddc8b1a5e54d0b0aecbddb3e1",
                "id": "4f50192ddc8b1a5e54d0b0aecbddb3e1"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 2,
                "elementId": "874fedead1608be3eeb424c29b015574",
                "id": "874fedead1608be3eeb424c29b015574"
              },
              {
                "type": "br",
                "position": 3,
                "elementId": "703664e89ac7a7721b07070b06650ca8",
                "id": "703664e89ac7a7721b07070b06650ca8"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 4,
                "elementId": "ae73fcad2561a103478857b5b12df66d",
                "id": "ae73fcad2561a103478857b5b12df66d"
              },
              {
                "type": "br",
                "position": 5,
                "elementId": "c740a80bad77b9c8ea9e5d2ba09c49d9",
                "id": "c740a80bad77b9c8ea9e5d2ba09c49d9"
              },
              {
                "type": "listitem",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 6,
                "elementId": "9ea29840c55388991d9d5285dd776a97",
                "id": "9ea29840c55388991d9d5285dd776a97"
              }
            ],
            "properties": {
              "classes": "whatsnext"
            },
            "position": 0,
            "componentId": "8fb71e082c3bc4dad4ce3a01c3c06e60",
            "id": "8fb71e082c3bc4dad4ce3a01c3c06e60"
          }
        ],
        "position": 4,
        "routeId": "afd0ba4567c0b04b85a3f558575280a5",
        "id": "afd0ba4567c0b04b85a3f558575280a5"
      },
      {
        "route": "/video",
        "components": [
          {
            "type": "video",
            "elements": [
              {
                "type": "header",
                "value": "Section template: /video",
                "position": 0,
                "elementId": "85f3eb238243bb1d62ad8d8d7af46806",
                "id": "85f3eb238243bb1d62ad8d8d7af46806"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 1,
                "elementId": "400fdbba772525e079c8ffd45e08cb03",
                "id": "400fdbba772525e079c8ffd45e08cb03"
              }
            ],
            "properties": {
              "duration": "7:31",
              "vimeoId": "123456789"
            },
            "position": 0,
            "componentId": "7ab42ef7880b29b76bed0b433b04fdc7",
            "id": "7ab42ef7880b29b76bed0b433b04fdc7"
          }
        ],
        "position": 5,
        "routeId": "c0a781549e43151bd0069b07562d1e73",
        "id": "c0a781549e43151bd0069b07562d1e73"
      },
      {
        "route": "/videos",
        "components": [
          {
            "type": "video",
            "elements": [],
            "properties": {
              "duration": "0:46",
              "vimeoId": "466180662"
            },
            "position": 0,
            "componentId": "df0b6431a7c0618ff0f83b8da3451a21",
            "id": "df0b6431a7c0618ff0f83b8da3451a21"
          },
          {
            "type": "video",
            "elements": [],
            "properties": {
              "duration": "0:44",
              "vimeoId": "466180904"
            },
            "position": 1,
            "componentId": "20f3e17a3130fd9d321221b9a6f5d4ef",
            "id": "20f3e17a3130fd9d321221b9a6f5d4ef"
          },
          {
            "type": "video",
            "elements": [],
            "properties": {
              "duration": "0:37",
              "vimeoId": "466180822"
            },
            "position": 2,
            "componentId": "1f0811e11a4216efa972c0dd96ba0929",
            "id": "1f0811e11a4216efa972c0dd96ba0929"
          }
        ],
        "properties": {
          "introHeader": "Stories",
          "introText": "Now watch these short films about successful people from different backgrounds."
        },
        "position": 29,
        "routeId": "9106f1b0608622a7029357f8bbe06b19",
        "id": "9106f1b0608622a7029357f8bbe06b19"
      },
      {
        "route": "/rating/audio",
        "components": [
          {
            "type": "page",
            "elements": [
              {
                "type": "header",
                "value": "Section template: /rating/audio",
                "position": 0,
                "elementId": "3901a72e55b2577fa30f04fb781219e6",
                "id": "3901a72e55b2577fa30f04fb781219e6"
              }
            ],
            "subComponents": [
              {
                "type": "rating-component",
                "elements": [],
                "properties": {
                  "id": "1",
                  "audio": "/general2/902MWN04A.mp3",
                  "video": "258095795",
                  "thumbnail": "/general2/902MWN04V.jpg",
                  "duration": "0:24",
                  "gender": "M",
                  "race": "W",
                  "lowersocio": "N"
                },
                "position": 0,
                "parentComponentId": "15e475d030d0995a0af2e6f57e37a025",
                "componentId": "8ad49a645b5ecc0c8bba037ad7726447",
                "id": "8ad49a645b5ecc0c8bba037ad7726447"
              },
              {
                "type": "rating-component",
                "elements": [],
                "properties": {
                  "id": "2",
                  "audio": "/general2/906MBY04A.mp3",
                  "video": "258096383",
                  "thumbnail": "/general2/906MBY04V.jpg",
                  "duration": "0:42",
                  "gender": "M",
                  "race": "B",
                  "lowersocio": "Y"
                },
                "position": 1,
                "parentComponentId": "15e475d030d0995a0af2e6f57e37a025",
                "componentId": "f6cca4fdd3a29d41a03ba4f758dd3c83",
                "id": "f6cca4fdd3a29d41a03ba4f758dd3c83"
              },
              {
                "type": "rating-component",
                "elements": [],
                "properties": {
                  "id": "3",
                  "audio": "/general2/908MAY04A.mp3",
                  "video": "258095871",
                  "thumbnail": "/general2/908MAY04V.jpg",
                  "duration": "0:35",
                  "gender": "M",
                  "race": "A",
                  "lowersocio": "Y"
                },
                "position": 2,
                "parentComponentId": "15e475d030d0995a0af2e6f57e37a025",
                "componentId": "f967eaa349c41dcb9a1327f33cbbf74b",
                "id": "f967eaa349c41dcb9a1327f33cbbf74b"
              },
              {
                "type": "rating-component",
                "elements": [],
                "properties": {
                  "id": "4",
                  "audio": "/general2/909FWN04A.mp3",
                  "video": "258095922",
                  "thumbnail": "/general2/909FWN04V.jpg",
                  "duration": "0:36",
                  "gender": "F",
                  "race": "W",
                  "lowersocio": "N"
                },
                "position": 3,
                "parentComponentId": "15e475d030d0995a0af2e6f57e37a025",
                "componentId": "936219ed22305b26be879fea52d5f895",
                "id": "936219ed22305b26be879fea52d5f895"
              },
              {
                "type": "rating-component",
                "elements": [],
                "properties": {
                  "id": "5",
                  "audio": "/general2/914FBY04A.mp3",
                  "video": "258095973",
                  "thumbnail": "/general2/914FBY04V.jpg",
                  "duration": "0:22",
                  "gender": "F",
                  "race": "B",
                  "lowersocio": "Y"
                },
                "position": 4,
                "parentComponentId": "15e475d030d0995a0af2e6f57e37a025",
                "componentId": "01bdfa7a5d9364b5b891477e24b5fc76",
                "id": "01bdfa7a5d9364b5b891477e24b5fc76"
              },
              {
                "type": "rating-component",
                "elements": [],
                "properties": {
                  "id": "5",
                  "audio": "/general2/914FBY04A.mp3",
                  "video": "258095973",
                  "thumbnail": "/general2/914FBY04V.jpg",
                  "duration": "0:22",
                  "gender": "F",
                  "race": "B",
                  "lowersocio": "Y"
                },
                "position": 5,
                "parentComponentId": "15e475d030d0995a0af2e6f57e37a025",
                "componentId": "01bdfa7c5d9364b5b891477e24b5fc76",
                "id": "01bdfa7c5d9364b5b891477e24b5fc76"
              }
            ],
            "position": 0,
            "componentId": "15e475d030d0995a0af2e6f57e37a025",
            "id": "15e475d030d0995a0af2e6f57e37a025"
          }
        ],
        "properties": {
          "type": "audio"
        },
        "position": 39,
        "routeId": "74c50ce02319451e11140be9d3cdab7d",
        "id": "74c50ce02319451e11140be9d3cdab7d"
      },
      {
        "route": "/rating/video",
        "components": [
          {
            "type": "page",
            "elements": [
              {
                "type": "header",
                "value": "Section template: /rating/video",
                "position": 0,
                "elementId": "d00fc49812857022f2434df9facb5665",
                "id": "d00fc49812857022f2434df9facb5665"
              }
            ],
            "subComponents": [
              {
                "type": "rating-component",
                "elements": [],
                "properties": {
                  "id": "2",
                  "audio": "/general2/906MBY04A.mp3",
                  "video": "258096383",
                  "thumbnail": "/general2/906MBY04V.jpg",
                  "duration": "0:42",
                  "gender": "M",
                  "race": "B",
                  "lowersocio": "Y"
                },
                "position": 0,
                "parentComponentId": "97ea5ebfb7949ca84b4e5e66ed556b69",
                "componentId": "51cd553befbf1e153590e25a62f77d9d",
                "id": "51cd553befbf1e153590e25a62f77d9d"
              },
              {
                "type": "rating-component",
                "elements": [],
                "properties": {
                  "id": "5",
                  "audio": "/general2/914FBY04A.mp3",
                  "video": "258095973",
                  "thumbnail": "/general2/914FBY04V.jpg",
                  "duration": "0:22",
                  "gender": "F",
                  "race": "B",
                  "lowersocio": "Y"
                },
                "position": 1,
                "parentComponentId": "97ea5ebfb7949ca84b4e5e66ed556b69",
                "componentId": "748b554eb6c7b555e79196016961ad0a",
                "id": "748b554eb6c7b555e79196016961ad0a"
              },
              {
                "type": "rating-component",
                "elements": [],
                "properties": {
                  "id": "1",
                  "audio": "/general2/902MWN04A.mp3",
                  "video": "258095795",
                  "thumbnail": "/general2/902MWN04V.jpg",
                  "duration": "0:24",
                  "gender": "M",
                  "race": "W",
                  "lowersocio": "N"
                },
                "position": 2,
                "parentComponentId": "97ea5ebfb7949ca84b4e5e66ed556b69",
                "componentId": "ec760f55fac601043ed057dd72dd848a",
                "id": "ec760f55fac601043ed057dd72dd848a"
              },
              {
                "type": "rating-component",
                "elements": [],
                "properties": {
                  "id": "4",
                  "audio": "/general2/909FWN04A.mp3",
                  "video": "258095922",
                  "thumbnail": "/general2/909FWN04V.jpg",
                  "duration": "0:36",
                  "gender": "F",
                  "race": "W",
                  "lowersocio": "N"
                },
                "position": 3,
                "parentComponentId": "97ea5ebfb7949ca84b4e5e66ed556b69",
                "componentId": "a26a24a269b27e8020c7abff11934e0d",
                "id": "a26a24a269b27e8020c7abff11934e0d"
              },
              {
                "type": "rating-component",
                "elements": [],
                "properties": {
                  "id": "3",
                  "audio": "/general2/908MAY04A.mp3",
                  "video": "258095871",
                  "thumbnail": "/general2/908MAY04V.jpg",
                  "duration": "0:35",
                  "gender": "M",
                  "race": "A",
                  "lowersocio": "Y"
                },
                "position": 4,
                "parentComponentId": "97ea5ebfb7949ca84b4e5e66ed556b69",
                "componentId": "1182c5bbc881cf6f800014fbfc2f45be",
                "id": "1182c5bbc881cf6f800014fbfc2f45be"
              },
              {
                "type": "rating-component",
                "elements": [],
                "properties": {
                  "id": "3",
                  "audio": "/general2/908MAY04A.mp3",
                  "video": "258095871",
                  "thumbnail": "/general2/908MAY04V.jpg",
                  "duration": "0:35",
                  "gender": "M",
                  "race": "A",
                  "lowersocio": "Y"
                },
                "position": 5,
                "parentComponentId": "97ea5ebfb7949ca84b4e5e66ed556b69",
                "componentId": "132c5bbc881cf6f800014fbfc2f45be",
                "id": "132c5bbc881cf6f800014fbfc2f45be"
              }
            ],
            "position": 0,
            "componentId": "97ea5ebfb7949ca84b4e5e66ed556b69",
            "id": "97ea5ebfb7949ca84b4e5e66ed556b69"
          }
        ],
        "properties": {
          "type": "video"
        },
        "position": 40,
        "routeId": "c1ce3bb18b9a28fc2544ba14513d6714",
        "id": "c1ce3bb18b9a28fc2544ba14513d6714"
      },
      {
        "route": "/rating/results",
        "components": [
          {
            "type": "page",
            "elements": [
              {
                "type": "question",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 0,
                "elementId": "b861a71c46a1bddfdeb7cf4381f56bbd",
                "id": "b861a71c46a1bddfdeb7cf4381f56bbd"
              }
            ],
            "subComponents": [
              {
                "type": "above-ratings",
                "elements": [
                  {
                    "type": "header",
                    "value": "Lorem ipsum dolor sit amet.",
                    "position": 0,
                    "elementId": "a46ef3d4cb3b91c246a65452285a398a",
                    "id": "a46ef3d4cb3b91c246a65452285a398a"
                  },
                  {
                    "type": "p",
                    "value": "Lorem ipsum dolor sit amet.",
                    "position": 1,
                    "elementId": "3d20c7bb08cac9b4512cb7230e79995f",
                    "id": "3d20c7bb08cac9b4512cb7230e79995f"
                  },
                  {
                    "type": "p",
                    "value": "Lorem ipsum dolor sit amet.",
                    "position": 2,
                    "elementId": "feebec4aae123d5e972846a51d006913",
                    "id": "feebec4aae123d5e972846a51d006913"
                  },
                  {
                    "type": "p",
                    "value": "Lorem ipsum dolor sit amet.",
                    "position": 3,
                    "elementId": "ba0daa80becd7c16eb177a7e5efd3e1a",
                    "id": "ba0daa80becd7c16eb177a7e5efd3e1a"
                  }
                ],
                "position": 0,
                "parentComponentId": "6430c51d2020d4c4c657c5b6c793f59e",
                "componentId": "d91d803ef60173a59f6cfacb1eedddf5",
                "id": "d91d803ef60173a59f6cfacb1eedddf5"
              },
              {
                "type": "below-ratings",
                "elements": [
                  {
                    "type": "p",
                    "value": "Lorem ipsum dolor sit amet.",
                    "position": 0,
                    "elementId": "51192909abdcfa5cc3f9a85cec739901",
                    "id": "51192909abdcfa5cc3f9a85cec739901"
                  }
                ],
                "position": 1,
                "parentComponentId": "6430c51d2020d4c4c657c5b6c793f59e",
                "componentId": "7b28f5f24ede37638e2dde8f943813e9",
                "id": "7b28f5f24ede37638e2dde8f943813e9"
              }
            ],
            "position": 0,
            "componentId": "6430c51d2020d4c4c657c5b6c793f59e",
            "id": "6430c51d2020d4c4c657c5b6c793f59e"
          }
        ],
        "properties": {
          "showBias": "false"
        },
        "position": 67,
        "routeId": "0c3f23a24122e676ee72160071d0ef65",
        "id": "0c3f23a24122e676ee72160071d0ef65"
      },
      {
        "route": "/quiz",
        "components": [
          {
            "type": "page",
            "elements": [
              {
                "type": "question",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 0,
                "elementId": "9cca2c860815680344443d6251d64158",
                "id": "9cca2c860815680344443d6251d64158"
              },
              {
                "type": "answer-item",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 1,
                "elementId": "02b72971bea8846b1e121c11d0de9a3c",
                "id": "02b72971bea8846b1e121c11d0de9a3c"
              },
              {
                "type": "answer-item",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 2,
                "elementId": "de45e53fd81b975ff29a3efd27d8f049",
                "id": "de45e53fd81b975ff29a3efd27d8f049"
              },
              {
                "type": "answer-item",
                "value": "Lorem ipsum dolor sit amet.",
                "properties": {
                  "correct": "true"
                },
                "position": 3,
                "elementId": "d784364e7e99fca702790bc082d215f2",
                "id": "d784364e7e99fca702790bc082d215f2"
              },
              {
                "type": "answer-item",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 4,
                "elementId": "6de1b8fe81339d713e9a1fb09cbbb244",
                "id": "6de1b8fe81339d713e9a1fb09cbbb244"
              }
            ],
            "position": 0,
            "componentId": "51f10ab9d63cd100cb9b89628579d7d2",
            "id": "51f10ab9d63cd100cb9b89628579d7d2"
          },
          {
            "type": "page",
            "elements": [
              {
                "type": "question",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 0,
                "elementId": "2b9fff8f9494d81fa3435ea21c4ad7bd",
                "id": "2b9fff8f9494d81fa3435ea21c4ad7bd"
              },
              {
                "type": "answer-item",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 1,
                "elementId": "365a2360f32a748e25aca8a2967a0652",
                "id": "365a2360f32a748e25aca8a2967a0652"
              },
              {
                "type": "answer-item",
                "value": "Lorem ipsum dolor sit amet.",
                "properties": {
                  "correct": "true"
                },
                "position": 2,
                "elementId": "011baed3a2dbb584f3f08216a43bcc91",
                "id": "011baed3a2dbb584f3f08216a43bcc91"
              },
              {
                "type": "answer-item",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 3,
                "elementId": "4622fb0d0c0c4dacdadf8d88e3b0651f",
                "id": "4622fb0d0c0c4dacdadf8d88e3b0651f"
              },
              {
                "type": "answer-item",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 4,
                "elementId": "0f1d4b2f09ef7cd19d7c10a6e2097da5",
                "id": "0f1d4b2f09ef7cd19d7c10a6e2097da5"
              }
            ],
            "position": 1,
            "componentId": "86d2b8e0b17d47bc71fd27fe781bc0c2",
            "id": "86d2b8e0b17d47bc71fd27fe781bc0c2"
          },
          {
            "type": "page",
            "elements": [
              {
                "type": "question",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 0,
                "elementId": "f7af19b88e6c7c56cde4e1ba41c36b6f",
                "id": "f7af19b88e6c7c56cde4e1ba41c36b6f"
              },
              {
                "type": "answer-item",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 1,
                "elementId": "32fecb28e63851e916d3ea7c8a78ec6f",
                "id": "32fecb28e63851e916d3ea7c8a78ec6f"
              },
              {
                "type": "answer-item",
                "value": "Lorem ipsum dolor sit amet.",
                "properties": {
                  "correct": "true"
                },
                "position": 2,
                "elementId": "7f1ea6be1e1f3169466b6c5289e8c0a9",
                "id": "7f1ea6be1e1f3169466b6c5289e8c0a9"
              },
              {
                "type": "answer-item",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 3,
                "elementId": "6933d3e2b85545cc1f07b5778f905327",
                "id": "6933d3e2b85545cc1f07b5778f905327"
              },
              {
                "type": "answer-item",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 4,
                "elementId": "85cb159173d5cf9a80cff890df58a414",
                "id": "85cb159173d5cf9a80cff890df58a414"
              }
            ],
            "position": 2,
            "componentId": "5233292240e0978e5fb4d92d949178b3",
            "id": "5233292240e0978e5fb4d92d949178b3"
          },
          {
            "type": "page",
            "elements": [
              {
                "type": "question",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 0,
                "elementId": "076e5bcfee67b0d6fd4dca5ad666ccbb",
                "id": "076e5bcfee67b0d6fd4dca5ad666ccbb"
              },
              {
                "type": "answer-item",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 1,
                "elementId": "29e312dbfcfe71eb09f357b89d0f8e0c",
                "id": "29e312dbfcfe71eb09f357b89d0f8e0c"
              },
              {
                "type": "answer-item",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 2,
                "elementId": "cb1e3d63b2f8ea411000bcc11046945e",
                "id": "cb1e3d63b2f8ea411000bcc11046945e"
              },
              {
                "type": "answer-item",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 3,
                "elementId": "c13deed4c32e20b1de98189858c1e4ee",
                "id": "c13deed4c32e20b1de98189858c1e4ee"
              },
              {
                "type": "answer-item",
                "value": "Lorem ipsum dolor sit amet.",
                "properties": {
                  "correct": "true"
                },
                "position": 4,
                "elementId": "3b672ad897e5ab343eaa485e78a816fc",
                "id": "3b672ad897e5ab343eaa485e78a816fc"
              }
            ],
            "position": 3,
            "componentId": "427b8f526ee1042cd291d701ef5ef29e",
            "id": "427b8f526ee1042cd291d701ef5ef29e"
          }
        ],
        "position": 70,
        "routeId": "ef4a9a166a5b8dfc368f2f7a438f6914",
        "id": "ef4a9a166a5b8dfc368f2f7a438f6914"
      },
      {
        "route": "/expand",
        "components": [
          {
            "type": "statement",
            "elements": [
              {
                "type": "header",
                "value": "Section template: /expand",
                "position": 0,
                "elementId": "04f18795107c99de238c18bedf8536e4",
                "id": "04f18795107c99de238c18bedf8536e4"
              }
            ],
            "subComponents": [
              {
                "type": "page",
                "elements": [
                  {
                    "type": "p",
                    "value": "Lorem ipsum dolor sit amet.",
                    "position": 0,
                    "elementId": "69cdf6a26aa19700e8667ff98983ab6c",
                    "id": "69cdf6a26aa19700e8667ff98983ab6c"
                  }
                ],
                "position": 0,
                "parentComponentId": "ea046dd963f943510ad0fb002c0dce73",
                "componentId": "f52253024d059bdb89ff699c3a1628db",
                "id": "f52253024d059bdb89ff699c3a1628db"
              }
            ],
            "position": 0,
            "componentId": "ea046dd963f943510ad0fb002c0dce73",
            "id": "ea046dd963f943510ad0fb002c0dce73"
          }
        ],
        "position": 80,
        "routeId": "209e7664449dc71e317ddabed092be30",
        "id": "209e7664449dc71e317ddabed092be30"
      },
      {
        "route": "/reminders",
        "components": [
          {
            "type": "action",
            "elements": [
              {
                "type": "header",
                "value": "Introductory page for reminders. Sizing of this page is important.",
                "position": 0,
                "elementId": "5a17bd79681fa52ae707df05cf5dde09",
                "id": "5a17bd79681fa52ae707df05cf5dde09"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 1,
                "elementId": "783e9c95fda11d28a4897ddcf61a68d6",
                "id": "783e9c95fda11d28a4897ddcf61a68d6"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 2,
                "elementId": "4f245d14efe77228b85ae14e45703e55",
                "id": "4f245d14efe77228b85ae14e45703e55"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 3,
                "elementId": "4fe07bd38a4d8885403e78f179327529",
                "id": "4fe07bd38a4d8885403e78f179327529"
              },
              {
                "type": "action-button-example",
                "position": 4,
                "elementId": "4ed6b5e7735305e178d468970bf96dd4",
                "id": "4ed6b5e7735305e178d468970bf96dd4"
              }
            ],
            "properties": {
              "image": "slide_intro.png"
            },
            "position": 0,
            "componentId": "e4bcf65076b037d438dbdc59a98840ab",
            "id": "e4bcf65076b037d438dbdc59a98840ab"
          },
          {
            "type": "action",
            "elements": [
              {
                "type": "header",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 0,
                "elementId": "6479a3ccd99c1551ebf5f0bab992016a",
                "id": "6479a3ccd99c1551ebf5f0bab992016a"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 1,
                "elementId": "92e5485e5454cc75628ce06656b00391",
                "id": "92e5485e5454cc75628ce06656b00391"
              }
            ],
            "properties": {
              "image": "01.png"
            },
            "position": 1,
            "componentId": "680aff1cc1f79f7d38b041d4122b5722",
            "id": "680aff1cc1f79f7d38b041d4122b5722"
          },
          {
            "type": "action",
            "elements": [
              {
                "type": "header",
                "value": "Final action page, please check its properties carefully.",
                "position": 0,
                "elementId": "0b4f3300e6bbedfaae616c858da55d44",
                "id": "0b4f3300e6bbedfaae616c858da55d44"
              }
            ],
            "properties": [],
            "position": 27,
            "componentId": "0f90cc2e45f3446fa15da8c4923e14bb",
            "id": "0f90cc2e45f3446fa15da8c4923e14bb"
          }
        ],
        "properties": {
          "dontEmailActions": "true",
          "type": "reminders",
          "images": "general2",
          "itemName": "Reminders",
          "requiredToSelect": "1"
        },
        "position": 122,
        "routeId": "21603a950227307be691cf95b7dc889c",
        "id": "21603a950227307be691cf95b7dc889c"
      },
            {
        "route": "/actions",
        "components": [
          {
            "type": "action",
            "elements": [
              {
                "type": "header",
                "value": "Introductory page for actions. Sizing of this page is important.",
                "position": 0,
                "elementId": "5a17bd79681fa52ae707df05cf5dde09",
                "id": "5a17bd79681fa52ae707df05cf5dde09"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 1,
                "elementId": "783e9c95fda11d28a4897ddcf61a68d6",
                "id": "783e9c95fda11d28a4897ddcf61a68d6"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 2,
                "elementId": "4f245d14efe77228b85ae14e45703e55",
                "id": "4f245d14efe77228b85ae14e45703e55"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 3,
                "elementId": "4fe07bd38a4d8885403e78f179327529",
                "id": "4fe07bd38a4d8885403e78f179327529"
              },
              {
                "type": "action-button-example",
                "position": 4,
                "elementId": "4ed6b5e7735305e178d468970bf96dd4",
                "id": "4ed6b5e7735305e178d468970bf96dd4"
              }
            ],
            "properties": {
              "image": "slide_intro.png"
            },
            "position": 0,
            "componentId": "e4bcf65076b037d438dbdc59a98840ab",
            "id": "e4bcf65076b037d438dbdc59a98840ab"
          },
          {
            "type": "action",
            "elements": [
              {
                "type": "header",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 0,
                "elementId": "6479a3ccd99c1551ebf5f0bab992016a",
                "id": "6479a3ccd99c1551ebf5f0bab992016a"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 1,
                "elementId": "92e5485e5454cc75628ce06656b00391",
                "id": "92e5485e5454cc75628ce06656b00391"
              }
            ],
            "properties": {
              "image": "01.png"
            },
            "position": 1,
            "componentId": "680aff1cc1f79f7d38b041d4122b5722",
            "id": "680aff1cc1f79f7d38b041d4122b5722"
          },
          {
            "type": "action",
            "elements": [
              {
                "type": "header",
                "value": "Final action page, please check its properties carefully.",
                "position": 0,
                "elementId": "0b4f3300e6bbedfaae616c858da55d44",
                "id": "0b4f3300e6bbedfaae616c858da55d44"
              }
            ],
            "properties": [],
            "position": 27,
            "componentId": "0f90cc2e45f3446fa15da8c4923e14bb",
            "id": "0f90cc2e45f3446fa15da8c4923e14bb"
          }
        ],
        "properties": {
          "dontEmailActions": "true",
          "type": "actions",
          "images": "general2",
          "itemName": "Actions",
          "requiredToSelect": "1"
        },
        "position": 122,
        "routeId": "21603a950227307be691cf95b7dc889c",
        "id": "21603a950227307be691cf95b7dc889c"
      },
      {
        "route": "/reflection",
        "components": [
          {
            "type": "page",
            "elements": [
              {
                "type": "header",
                "value": "Section template: /reflection",
                "properties": {
                  "classes": "bold"
                },
                "position": 0,
                "elementId": "616bdebd86c546d4cf861f06a6775c59",
                "id": "616bdebd86c546d4cf861f06a6775c59"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 1,
                "elementId": "bb2db972c8b2fb0122c106616ed5ebeb",
                "id": "bb2db972c8b2fb0122c106616ed5ebeb"
              },
              {
                "type": "br",
                "position": 2,
                "elementId": "95857222a12ccaec33fcc98cb9d807a2",
                "id": "95857222a12ccaec33fcc98cb9d807a2"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 3,
                "elementId": "dec2e21d77b402a1fc81adf5105c1960",
                "id": "dec2e21d77b402a1fc81adf5105c1960"
              },
              {
                "type": "br",
                "position": 4,
                "elementId": "2fbe9f6be009fd690d17a2dd52778ff1",
                "id": "2fbe9f6be009fd690d17a2dd52778ff1"
              },
              {
                "type": "reflection-image",
                "position": 5,
                "elementId": "a2cffeb5bc879d1291ddd72425e1eb82",
                "id": "a2cffeb5bc879d1291ddd72425e1eb82"
              }
            ],
            "properties": {
              "intro": "true",
              "classes": "reflection-intro"
            },
            "position": 0,
            "componentId": "44e5b5b8852b6c7ea3d9eda9bdca6028",
            "id": "44e5b5b8852b6c7ea3d9eda9bdca6028"
          },
          {
            "type": "page",
            "elements": [
              {
                "type": "header",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 0,
                "elementId": "29912f9dbb522984972acfb3398ea806",
                "id": "29912f9dbb522984972acfb3398ea806"
              },
              {
                "type": "textarea",
                "properties": {
                  "placeholder": "Please enter your thoughts to continue."
                },
                "position": 1,
                "elementId": "8587fbb65a7ce9a94ede2157a55edfc9",
                "id": "8587fbb65a7ce9a94ede2157a55edfc9"
              }
            ],
            "position": 1,
            "componentId": "2ca5acb2a261a95af89bd5edeb067a1d",
            "id": "2ca5acb2a261a95af89bd5edeb067a1d"
          },
          {
            "type": "page",
            "elements": [
              {
                "type": "header",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 0,
                "elementId": "02187769bcf7d2818c34400837f552da",
                "id": "02187769bcf7d2818c34400837f552da"
              },
              {
                "type": "textarea",
                "properties": {
                  "placeholder": "Please enter your thoughts to continue"
                },
                "position": 1,
                "elementId": "8e5eaf7c5b4e9bb8ea2f53ae6c2a1309",
                "id": "8e5eaf7c5b4e9bb8ea2f53ae6c2a1309"
              }
            ],
            "position": 2,
            "componentId": "fb25b4b25ddbaf9ceb2553de72e6dc32",
            "id": "fb25b4b25ddbaf9ceb2553de72e6dc32"
          }
        ],
        "position": 125,
        "routeId": "286c4f4b6e9a1a14482389c2aa67e240",
        "id": "286c4f4b6e9a1a14482389c2aa67e240"
      },
      {
        "route": "/send-reflections",
        "components": [
          {
            "type": "page",
            "elements": [
              {
                "type": "header",
                "value": "Section template: /send-reflections",
                "position": 0,
                "elementId": "dba8c1c08dda87be029bcc0b2943b2c6",
                "id": "dba8c1c08dda87be029bcc0b2943b2c6"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 1,
                "elementId": "1ff3ba25670118ec31709c0f42dcea8b",
                "id": "1ff3ba25670118ec31709c0f42dcea8b"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 2,
                "elementId": "ba0a0ee48773a64bf3dfb1dd085e84de",
                "id": "ba0a0ee48773a64bf3dfb1dd085e84de"
              },
              {
                "type": "br",
                "position": 3,
                "elementId": "c66d8040398825b16ea295628e6d4927",
                "id": "c66d8040398825b16ea295628e6d4927"
              },
              {
                "type": "yes-no",
                "value": "Lorem ipsum dolor sit amet.",
                "properties": {
                  "sendTo": "self"
                },
                "position": 4,
                "elementId": "b9753ce3698ef4e9d7eeb16f78112182",
                "id": "b9753ce3698ef4e9d7eeb16f78112182"
              },
              {
                "type": "yes-no",
                "value": "Lorem ipsum dolor sit amet.",
                "properties": {
                  "sendTo": "hemisphere"
                },
                "position": 5,
                "elementId": "0dc0d7e5c58d7a04f4a289b5205acf6f",
                "id": "0dc0d7e5c58d7a04f4a289b5205acf6f"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 6,
                "elementId": "1ef8e411840f3d26b16910cb9b7e8696",
                "id": "1ef8e411840f3d26b16910cb9b7e8696"
              }
            ],
            "position": 0,
            "componentId": "c4ad00d0985a4918d11aacf243e80701",
            "id": "c4ad00d0985a4918d11aacf243e80701"
          }
        ],
        "properties": {
          "sendgridTemplateId": "d-b2d314b42d554d5a940c2be40e1113b5"
        },
        "position": 126,
        "routeId": "201ff33f6a47df1a73258960e2820c4a",
        "id": "201ff33f6a47df1a73258960e2820c4a"
      },
      {
        "route": "/cpd-certificate/name",
        "components": [
          {
            "type": "page",
            "elements": [
              {
                "type": "header",
                "value": "Certificate of Professional Development",
                "position": 0,
                "elementId": "82370913e7a5903e748c22c2d051fd40",
                "id": "82370913e7a5903e748c22c2d051fd40"
              },
              {
                "type": "p",
                "value": "Please enter your full name.",
                "position": 1,
                "elementId": "670e7f620686f3c23929c9d6b892682e",
                "id": "670e7f620686f3c23929c9d6b892682e"
              },
              {
                "type": "helper",
                "value": "Your certificate will be emailed to you.",
                "position": 2,
                "elementId": "a09eef9388cde450ac7795b8dbbd8379",
                "id": "a09eef9388cde450ac7795b8dbbd8379"
              }
            ],
            "position": 0,
            "componentId": "1c798e5d19cd3c3f9594fd7146efec83",
            "id": "1c798e5d19cd3c3f9594fd7146efec83"
          }
        ],
        "position": 127,
        "routeId": "0a11792dd37538ca89743288c0b0a2b7",
        "id": "0a11792dd37538ca89743288c0b0a2b7"
      },
      {
        "route": "/feedback",
        "components": [
          {
            "type": "page",
            "elements": [
              {
                "type": "header",
                "value": "Feedback start page.",
                "properties": {
                  "optional": "true"
                },
                "position": 0,
                "elementId": "c729318b53669cd617a483e8b4f71921",
                "id": "c729318b53669cd617a483e8b4f71921"
              },
              {
                "type": "reflection-image",
                "position": 1,
                "elementId": "64f3ce6b6c8fb03f081cdfe34ac9feef",
                "id": "64f3ce6b6c8fb03f081cdfe34ac9feef"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 2,
                "elementId": "396297da7e4b708bd8965962b78f6009",
                "id": "396297da7e4b708bd8965962b78f6009"
              }
            ],
            "properties": {
              "hidePageNumbers": "true",
              "classes": "has-reflection-image"
            },
            "position": 0,
            "componentId": "d583d691d090246cf8760484be3136e8",
            "id": "d583d691d090246cf8760484be3136e8"
          },
          {
            "type": "page",
            "elements": [
              {
                "type": "header",
                "value": "Feedback with drop down.",
                "position": 0,
                "elementId": "fddbd37dc3a0494299cf1d0f8a7ec4c0",
                "id": "fddbd37dc3a0494299cf1d0f8a7ec4c0"
              },
              {
                "type": "dropdown",
                "properties": {
                  "placeholder": "Please select"
                },
                "position": 1,
                "elementId": "1789698c2e9b30d96314554ba3eb0a7a",
                "id": "1789698c2e9b30d96314554ba3eb0a7a"
              },
              {
                "type": "answer-item",
                "value": "Option 1",
                "position": 2,
                "elementId": "f79ffff9e31017cb6918ec3f3ba26a80",
                "id": "f79ffff9e31017cb6918ec3f3ba26a80"
              },
              {
                "type": "answer-item",
                "value": "Option 2",
                "position": 3,
                "elementId": "1ca9f8291cea68560d37f00ada2d991a",
                "id": "1ca9f8291cea68560d37f00ada2d991a"
              }
            ],
            "properties": {
              "classes": "align-top"
            },
            "position": 1,
            "componentId": "7639f0a59feae3c8679f331eac5b604d",
            "id": "7639f0a59feae3c8679f331eac5b604d"
          },
          {
            "type": "page",
            "elements": [
              {
                "type": "header",
                "value": "Likert with 1-10 Strongly disagree to Strongly aggree",
                "position": 0,
                "elementId": "4c9593b78ae2130ea365cd091f2082d0",
                "id": "4c9593b78ae2130ea365cd091f2082d0"
              },
              {
                "type": "likert",
                "properties": {
                  "scale": "10",
                  "leftLabel": "Strongly disagree",
                  "rightLabel": "Strongly agree"
                },
                "position": 1,
                "elementId": "79e76a2adb2118586225b57605b498dd",
                "id": "79e76a2adb2118586225b57605b498dd"
              }
            ],
            "position": 2,
            "componentId": "de97a3080be809ad04a567d02d60f3ed",
            "id": "de97a3080be809ad04a567d02d60f3ed"
          },
          {
            "type": "page",
            "elements": [
              {
                "type": "header",
                "value": "Likert 1-10 Not at all likely to Extremely Likely",
                "position": 0,
                "elementId": "fd85ed6315681e0dd615d48ea3ea43f7",
                "id": "fd85ed6315681e0dd615d48ea3ea43f7"
              },
              {
                "type": "likert",
                "properties": {
                  "scale": "10",
                  "leftLabel": "Not at all likely",
                  "rightLabel": "Extremely likely"
                },
                "position": 1,
                "elementId": "d1fd95d6d67eb83feeabd0c699a0c919",
                "id": "d1fd95d6d67eb83feeabd0c699a0c919"
              }
            ],
            "position": 3,
            "componentId": "a7e6ceeeca892ba0aba961feedc527be",
            "id": "a7e6ceeeca892ba0aba961feedc527be"
          },
          {
            "type": "page",
            "elements": [
              {
                "type": "header",
                "value": "Please enter textarea",
                "properties": {
                  "optional": "true"
                },
                "position": 0,
                "elementId": "9a811c8592c0dcfc79bb30d4f0ddb560",
                "id": "9a811c8592c0dcfc79bb30d4f0ddb560"
              },
              {
                "type": "textarea",
                "properties": {
                  "placeholder": "Enter your answer. Please note feedback may be shared with your employer, anonymously."
                },
                "position": 1,
                "elementId": "c0275e3ffc7fd590d4f7431b9a3f31e7",
                "id": "c0275e3ffc7fd590d4f7431b9a3f31e7"
              }
            ],
            "properties": {
              "align-items": "top"
            },
            "position": 4,
            "componentId": "b342872b65ec37016055f5838e9b86df",
            "id": "b342872b65ec37016055f5838e9b86df"
          },
          {
            "type": "page",
            "elements": [
              {
                "type": "header",
                "value": "Optional page to enter email address.",
                "properties": {
                  "optional": "true"
                },
                "position": 0,
                "elementId": "2cf166a58f3a735528b52d1d1b4ab215",
                "id": "2cf166a58f3a735528b52d1d1b4ab215"
              },
              {
                "type": "email",
                "properties": {
                  "placeholder": "Enter your email address. We will not share your details or contact you for any other reason."
                },
                "position": 1,
                "elementId": "9b6f573ac62bcd8d13a428337710820a",
                "id": "9b6f573ac62bcd8d13a428337710820a"
              }
            ],
            "properties": {
              "classes": "align-top"
            },
            "position": 9,
            "componentId": "9c75ecf96229058641568fc7c6dac914",
            "id": "9c75ecf96229058641568fc7c6dac914"
          }
        ],
        "position": 128,
        "routeId": "abe1bda4ebe4227c051349c7166820d8",
        "id": "abe1bda4ebe4227c051349c7166820d8"
      },
      {
        "route": "/complete",
        "components": [
          {
            "type": "page",
            "elements": [
              {
                "type": "header",
                "value": "Last page, where we have a property to send actions or not.",
                "position": 0,
                "elementId": "456bbe0b93d7a694da1b2add2e653313",
                "id": "456bbe0b93d7a694da1b2add2e653313"
              },
              {
                "type": "hr",
                "position": 1,
                "elementId": "c4eaa8bf0d7bdc3ede65ad85a07be57a",
                "id": "c4eaa8bf0d7bdc3ede65ad85a07be57a"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 2,
                "elementId": "88905dfd60aa5e260e42ef4bdbee54e5",
                "id": "88905dfd60aa5e260e42ef4bdbee54e5"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 3,
                "elementId": "966110576b2f1077959f36e2cc25ffbd",
                "id": "966110576b2f1077959f36e2cc25ffbd"
              },
              {
                "type": "p",
                "value": "Lorem ipsum dolor sit amet.",
                "position": 4,
                "elementId": "07f4bd9e9c030dcb4d704d89e240aa16",
                "id": "07f4bd9e9c030dcb4d704d89e240aa16"
              }
            ],
            "properties": {
              "haveNextButton": "false",
              "haveContentLibraryButton": "true",
              "classes": "welcome-text-container wide"
            },
            "position": 0,
            "componentId": "eac7d5b78cebb4c08d4b79d32bc68101",
            "id": "eac7d5b78cebb4c08d4b79d32bc68101"
          }
        ],
        "properties": {
          "emailActions": "true"
        },
        "position": 129,
        "routeId": "7e56ee99c87193ead78ab97c9077005f",
        "id": "7e56ee99c87193ead78ab97c9077005f"
      }
    ],
    "metadata": {
      "properties": {
        "name": "CLIENT | Hemisphere Master Content Library",
        "type": "training",
        "version": "0"
      }
    }
  },
  "version": 12
}
